import * as THREE from 'three';
import { INTERACTIVE_USER_DATA_KEY } from '../types.js';
import { mat } from './palette.js';
import { woodMaterial } from './materials.js';

export interface BrandEntranceSign {
  group: THREE.Group;
  logoPlane: THREE.Mesh;
  spot: THREE.SpotLight;
  applyLogo(texture: THREE.Texture): void;
}

export function createBrandEntranceSign(): BrandEntranceSign {
  const group = new THREE.Group();
  group.position.set(0, 0, 13.2);

  const frame = new THREE.Mesh(new THREE.BoxGeometry(3.4, 2.1, 0.18), woodMaterial(3, 0x5c3a22));
  frame.position.set(0, 2.55, 0);
  frame.castShadow = true;

  const back = new THREE.Mesh(new THREE.BoxGeometry(3.2, 1.9, 0.08), mat(0x2a1810, { roughness: 0.9 }));
  back.position.set(0, 2.55, -0.06);

  const logoPlane = new THREE.Mesh(
    new THREE.PlaneGeometry(2.85, 1.55),
    new THREE.MeshStandardMaterial({ color: 0xffffff, roughness: 0.85, metalness: 0.05 }),
  );
  logoPlane.position.set(0, 2.55, 0.1);

  const spot = new THREE.SpotLight(0xffc890, 1.1, 14, Math.PI / 5, 0.35, 1);
  spot.position.set(0, 4.2, 1.2);
  spot.target.position.set(0, 2.5, 0);
  group.add(spot, spot.target);

  const warm = new THREE.PointLight(0xffb060, 0.45, 8, 2);
  warm.position.set(0, 2.8, 0.6);
  group.add(frame, back, logoPlane, warm);

  return {
    group,
    logoPlane,
    spot,
    applyLogo(texture: THREE.Texture) {
      texture.colorSpace = THREE.SRGBColorSpace;
      texture.anisotropy = 8;
      const m = logoPlane.material as THREE.MeshStandardMaterial;
      m.map = texture;
      m.emissive = new THREE.Color(0xfff0dd);
      m.emissiveIntensity = 0.08;
      m.needsUpdate = true;
    },
  };
}

export function createWeatherStation(interactives: THREE.Object3D[]): THREE.Group {
  const g = new THREE.Group();
  g.position.set(5.2, 0, 10.8);

  const pedestal = new THREE.Mesh(new THREE.CylinderGeometry(0.22, 0.28, 0.95, 12), mat(0x666666, { metalness: 0.55 }));
  pedestal.position.y = 0.48;
  const kiosk = new THREE.Mesh(new THREE.BoxGeometry(0.75, 0.95, 0.42), mat(0x2a3540, { metalness: 0.35, roughness: 0.45 }));
  kiosk.position.y = 1.25;
  const screen = new THREE.Mesh(
    new THREE.PlaneGeometry(0.62, 0.42),
    new THREE.MeshStandardMaterial({
      color: 0x112233,
      emissive: 0x3388cc,
      emissiveIntensity: 0.55,
      roughness: 0.35,
    }),
  );
  screen.position.set(0, 1.25, 0.22);
  screen.userData[INTERACTIVE_USER_DATA_KEY] = 'weather-station';

  const cap = new THREE.Mesh(new THREE.SphereGeometry(0.12, 10, 8), mat(0xcccccc, { metalness: 0.7 }));
  cap.position.set(0, 1.85, 0);

  g.add(pedestal, kiosk, screen, cap);
  interactives.push(screen);
  return g;
}
